export default __webpack_public_path__ + "static/media/cupcakes.90fd6e1e.jpg";